
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { ICountryConfigResponse, IUpdateUserOID, IUser, IUserDetail } from "@/entities";
import { EUserType } from "@/services";

@Component({
  name: "user-detail",
})
export default class UserDetail extends Vue {
  @Action("toggleAdmin") toggleAdmin!: (idUser: number) => Promise<boolean | undefined>;
  @Action("toggleSupervisor") toggleSupervisor!: (idUser: number) => Promise<boolean | undefined>;
  @Action("toggleAprobador") toggleAprobador!: (idUser: number) => Promise<boolean | undefined>;
  @Action("fetchUserDetail") fetchUserDetail!: (idUser: number) => Promise<IUserDetail | undefined>;
  @Action("updateOIDSol") updateOIDSol!: ({
    idUser,
    updateUser,
  }: {
    idUser: number;
    updateUser: IUpdateUserOID;
  }) => Promise<string | undefined>;
  @Getter("getLoggedUser") loggedUser: IUser | undefined;
  @Prop({ required: true }) user!: IUserDetail;
  @Prop({ default: {} }) config!: ICountryConfigResponse;
  isDisableOIDSol = true;
  isApprovalFlowNotificationEnabled = false;

  constructor() {
    super();
  }

  mounted(): void {
    this.isApprovalFlowNotificationEnabled = this.user.approvalFlowNotificationsEnabled || false;
  }

  @Watch("user.approvalFlowNotificationsEnabled")
  onApprovalFlowNotificationsEnabledChanged(value: boolean | undefined): void {
    this.isApprovalFlowNotificationEnabled = value || false;
  }

  onCheckOIDSol(isChecked: boolean): void {
    this.isDisableOIDSol = isChecked;
  }
  async onCheckApprovalFlowNotificationEnabled(userId: number): Promise<void> {
    const isOK = await this.$services.user.toggleFlowApprovalNotification(userId);
    if (!isOK) {
      this.$swal.fire({
        title: this.$t("unexpectedError.title"),
        text: this.$t("unexpectedError.description"),
        icon: "error",
      });
    }
  }
  onUpdateOIDSol(id: number): void {
    const updateOID: IUpdateUserOID = {
      oid: this.user.oid!,
    };
    this.updateOIDSol({ idUser: id, updateUser: updateOID });
  }
  switchAdmin(id: number): void {
    this.toggleAdmin(id);
  }
  switchSupervisor(id: number): void {
    this.toggleSupervisor(id);
  }
  async switchAprobador(id: number): Promise<void> {
    await this.toggleAprobador(id);
    this.$emit("change", id);
  }

  get currentUserIsCorporate(): boolean {
    return this.loggedUser?.userType === EUserType.PROSEGUR;
  }
}
